var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_8932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.89355 3.85714L7.64714 1.10355C7.84241 0.908291 8.15899 0.908291 8.35425 1.10355L11.1078 3.85714",
    stroke: "#FA8503",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00098 1.78564V12.1428",
    stroke: "#FA8503",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 11.1069V13.2498C0.75 14.3544 1.64543 15.2498 2.75 15.2498H13.25C14.3546 15.2498 15.25 14.3544 15.25 13.2498V11.1069",
    stroke: "#FA8503",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_8932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridUploadIcon);
export default __webpack_public_path__ + "static/media/grid-upload-icon.0b27d7af4fce953626720020403d60fb.svg";
export { ForwardRef as ReactComponent };